// System fields
export const CLICKUP_ASSIGNEES = 'assignees';
export const CLICKUP_CREATOR = 'creator';
export const CLICKUP_WATCHERS = 'watchers';
export const CLICKUP_DESCRIPTION = 'description';
export const CLICKUP_NAME = 'name';
export const CLICKUP_STATUS = 'status';
export const CLICKUP_TAGS = 'tags';
export const CLICKUP_PRIORITY = 'priority';
export const CLICKUP_DUE_DATE = 'due_date';
export const CLICKUP_START_DATE = 'start_date';
export const CLICKUP_SPRINT_POINTS = 'points';
export const CLICKUP_TIME_ESTIMATE = 'time_estimate';
export const CLICKUP_TIME_SPENT = 'time_spent';

export const CLICKUP_SYSTEM_FIELDS = [
	CLICKUP_ASSIGNEES,
	CLICKUP_CREATOR,
	CLICKUP_WATCHERS,
	CLICKUP_DESCRIPTION,
	CLICKUP_NAME,
	CLICKUP_STATUS,
	CLICKUP_TAGS,
	CLICKUP_PRIORITY,
	CLICKUP_DUE_DATE,
	CLICKUP_START_DATE,
	CLICKUP_SPRINT_POINTS,
	CLICKUP_TIME_ESTIMATE,
	CLICKUP_TIME_SPENT,
];
